import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { decodeToken } from "@Shared/@Utils/utils";
import { isEmpty } from "lodash";
import Vue from "vue";
export const SET_CLIENT_DETAILS = "SET_CLIENT_DETAILS";
export const SET_TOKEN_DATA = "SET_TOKEN_DATA";
export const SET_FILL_OUT_RAW_SCHEMA = "SET_FILL_OUT_RAW_SCHEMA";
export const MARK_GUEST_FILL_OUT_APPLICATION_AS_SUBMITTED = "MARK_GUEST_FILL_OUT_APPLICATION_AS_SUBMITTED";
const mutations = {
  [SET_CLIENT_DETAILS]: (state, {
    clientDetails
  }) => {
    const {
      familyName,
      givenName
    } = clientDetails;
    Vue.set(state.guestFillOutDetails, "clientDetails", _objectSpread(_objectSpread({}, state.guestFillOutDetails.clientDetails), {}, {
      familyName,
      givenName
    }));
  },
  [SET_TOKEN_DATA]: (state, {
    token
  }) => {
    Vue.set(state.guestFillOutDetails, "token", token);
    const decodedToken = decodeToken(token);
    if (!isEmpty(decodedToken)) {
      const {
        app: applicationId,
        client: clientUsername,
        coApplicant: coApplicantId
      } = decodedToken;
      Vue.set(state.guestFillOutDetails, "clientDetails", _objectSpread(_objectSpread({}, state.guestFillOutDetails.clientDetails), {}, {
        applicationId,
        clientUsername,
        coApplicantId
      }));
    }
  },
  [SET_FILL_OUT_RAW_SCHEMA]: (state, {
    schema,
    fillOutSections
  }) => {
    var _context;
    const nonFlowKeys = ["customizationId", "metadata", "translationMap", "showDirectToLender"];
    const flowsKeys = _filterInstanceProperty(_context = _Object$keys(schema)).call(_context, key => !_includesInstanceProperty(nonFlowKeys).call(nonFlowKeys, key));
    const flows = _mapInstanceProperty(flowsKeys).call(flowsKeys, flow => schema[flow]);
    const filteredFlows = _mapInstanceProperty(flows).call(flows, flow => _filterInstanceProperty(flow).call(flow, ({
      key
    }) => _includesInstanceProperty(fillOutSections).call(fillOutSections, key)));
    const filteredFlowsObject = {};
    filteredFlows.forEach((value, index) => {
      filteredFlowsObject[flowsKeys[index]] = value;
    });
    state.rawSchema = _objectSpread(_objectSpread({}, schema), filteredFlowsObject);
  },
  [MARK_GUEST_FILL_OUT_APPLICATION_AS_SUBMITTED]: state => {
    var _coApplicants$find;
    const {
      coApplicantId
    } = state.guestFillOutDetails.clientDetails || {};
    const {
      coApplicants
    } = state.consolidatedRequest.metadata || {};
    const applicantRequest = (_coApplicants$find = coApplicants == null ? void 0 : _findInstanceProperty(coApplicants).call(coApplicants, ({
      id
    }) => id === coApplicantId)) != null ? _coApplicants$find : {};
    Vue.set(applicantRequest, "status", "submitted");
  }
};
export default mutations;